<div class="page-header">
    <div class="page-header__container container">
        <div class="page-header__breadcrumb">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb" itemscope itemtype="http://schema.org/BreadcrumbList">
                    <ng-container *ngFor="let breadcrumb of breadcrumbs; let i = index; last as last">
                        <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" *ngIf="!last" class="breadcrumb-item">
                            <a [routerLink]="breadcrumb.url" itemprop="item"><span itemprop="name">{{ breadcrumb.label }}</span></a>
                            <app-icon class="breadcrumb-arrow" name="arrow-rounded-right-6x9" size="6x9"></app-icon>
                            <meta itemprop="position" content="{{i}}" />
                        </li>
                        <li *ngIf="last" class="breadcrumb-item active" aria-current="page" style="padding-right: 0px;">
                            {{ breadcrumb.label }}</li>
                    </ng-container>
                </ol>
            </nav>
        </div>
        <div *ngIf="header" class="page-header__title">
            <h1>{{ header }}</h1>
        </div>
    </div>
</div>
